import { render, staticRenderFns } from "./qx-link.vue?vue&type=template&id=03bb522d&scoped=true"
import script from "./qx-link.vue?vue&type=script&lang=js"
export * from "./qx-link.vue?vue&type=script&lang=js"
import style0 from "./qx-link.vue?vue&type=style&index=0&id=03bb522d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb522d",
  null
  
)

export default component.exports